import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import { clone, get } from "lodash";
import { connect } from "react-redux";
import * as actions from "store/actions";

import Button from "components/CustomButtons/Button";
import Notification from "components/Notification/Notification";

import { defaultData as invoiceData } from "../../Invoices/InvoiceObj";
import RSheetsPDFPreview from "../RSheetsPDFPreview";

import { doAction, generateSections, renderHTML } from "./RSheetsResidentialLogic";
import { approveInvoices, checkViewApprove, getRsheetLadderOptions } from "../RSheetsLogic";
import RSheetsDenyModal from "../RSheetsDenyModal";
import InvoicePreview from "../CommonCustomElements/InvoicePreview";
import { INVOICE_STATUS } from "../../Invoices/InvoiceObj";
import InvoiceChoose from "../CommonCustomElements/InvoiceChoose";
import { getUser } from "../../../shared/authValidation";
import { calculateTotalInvoicePicture } from "../../Invoices/InvoiceLogic";
import devStatus, { gcibStatus } from "../../../shared/devStatus";
import { generateGCIB } from "../../CRM/GCIBoard/gciLogic";

const RSheetsResidentialFormActions = (props) => {
    const rsheetPerms = getRsheetLadderOptions();
    const levels = get(rsheetPerms, 'userPerms.approve', []);
    const max_approver_level = levels.length > 0 ? Math.max.apply(Math, levels) : null;

    const { invoiceID } = props;
    const [openedPDFPreview, setOpenedPDFPreview] = useState(false);
    const [loadedPDF, setLoadedPDF] = useState(false);
    const [notification, setNotification] = useState("");
    const [closeForm, setCloseForm] = useState(false);
    const [invoiceForm, setInvoiceForm] = useState(invoiceData);
    const [openedDenyModal, setOpenedDenyModal] = useState(false);
    const [invoicePreview, setInvoicePreview] = useState(null);
    const [openedChooseInvoice, setOpenedChooseInvoice] = useState(false);

    const handleApproveOrSubmit = async (invoiceData = null) => {
        const sections = generateSections(data, props.internalReviewers, null, props.the_invoices);
        let errors = [];
        sections.forEach((s) => {
            s.errors.forEach((e) => {
                errors.push(e);
            });
        });
        if (errors.length > 0) {
            const elem = (
                <div>
                    <h3>Required</h3>
                </div>
            );
            return setNotification(
                <div>
                    {elem}
                    {errors.map((e, x) => {
                        return <div key={`${x}-error`}>{e}</div>;
                    })}
                </div>
            );
        }
        setNotification("Sending...");

        if (!props.level || !isFinite(props.level)) {
            // SUBMITTER ONLY
            if (!data.id) {
                if (props.setHasSubmitted) {
                    props.setHasSubmitted(true);
                }
                const recordHistory = {
                    status: 2,
                    json_data: data
                }
                props.createRsheet(
                    {
                        json_data: JSON.stringify(data),
                        status: 2,
                        project_name: data.project_name,
                        type: 1, // RESIDENTIAL
                    },
                    invoiceData,
                    recordHistory
                );
            } else {
                if (props.setHasSubmitted) {
                    props.setHasSubmitted(true);
                }
                const updateObj = {
                    id: data.id,
                    json_data: JSON.stringify(data),
                    status: 2,
                    project_name: data.project_name,
                    notifyApprover: 1
                };
                const recordHistory = {
                    status: 2,
                    json_data: data,
                    rs_id: data.id
                }
                props.updateRsheet(updateObj, invoiceData, recordHistory);
                props.setFormDataObj({});
                setCloseForm(true);
            }
        } else {
            // APPROVER
            // --------
            // my tab = submitter is the same as approver and he is the highest level (4)
            let finalStatus = 2; // standard pending
            if (props.tab === "my_drafts") {
                if (props.level === 4) {
                    finalStatus = 9; // approve right away
                } else {
                    finalStatus = rsheetPerms.approveObj[props.level];
                }
            } else {
                finalStatus = rsheetPerms.approveObj[props.level];
            }
            const updateObj = {
                json_data: JSON.stringify(data),
                status: finalStatus,
                project_name: data.project_name,
                type: 1 // RESIDENTIAL
            };
            if (finalStatus === 9) {
                updateObj.notifySubmitter = 'Your routing sheet has been approved';
            }
            if (props.level !== 4) {
                updateObj.notifyApprover = props.level + 1;
            }
            const recordHistory = {
                status: finalStatus,
                json_data: data
            }
            if (!data.id) {
                props.createRsheet(updateObj, invoiceData, recordHistory);
            } else {
                updateObj.id = data.id;
                recordHistory.rs_id = data.id;
                if (finalStatus === 9) {
                    // create PDF
                    const pdfObj = {
                        htmlContent: renderHTML(data, props.rsheetData, props.the_invoices)
                    };
                    const invo_data = await calculateTotalInvoicePicture(data.id);
                    props.updateRsheet(updateObj, invoiceData, recordHistory, pdfObj, invo_data);
                    if (gcibStatus) {
                        generateGCIB(data, props.rsheetData?.id);
                    }
                } else {
                    props.updateRsheet(updateObj, invoiceData, recordHistory);
                }
            }
            setCloseForm(true);
            props.setFormDataObj({});
        }
    };

    const handlePreviewInvoice = () => {
        const { data } = props;

        const newInvoiceForm = clone(invoiceForm);
        newInvoiceForm.rsData = data;
        newInvoiceForm.title = `Generated from RS illi# ${get(data, "illi_number", "")}`;
        if (data.title) {
            const extraTitle = ` - Rev ${data.title.split("_").length}`;
            newInvoiceForm.title = newInvoiceForm.title + extraTitle;
        }
        newInvoiceForm.invoice = "001";
        newInvoiceForm.illi = get(data, "illi_number", "");
        newInvoiceForm.rs_id = data.id;

        const invoiceData = {
            status: 1,
            data: newInvoiceForm,
        };
        setInvoicePreview(invoiceData);
    }

    const handleGenerateInvoice = async () => {
        if (props.rsheetData.id) {
            const approved = await approveInvoices(props.rsheetData.id);
            if (approved) {
                handleApproveOrSubmit();
            } else {
                alert('There was an error. The invoices have not been approved yet.')
            }
        }
    };

    useEffect(() => {
        if (props.success) {
            if (props.success.indexOf("Created Sheet") !== -1) {
                props.setOpenedForm(false);
                doAction(props.tab, props.getRsheets);
            } else if (props.success === "Updated Sheet") {
                if (props.level) {
                    if (props.getAdminData) props.getAdminData();
                } else {
                    doAction(props.tab, props.getRsheets);
                }
                if (props.hasSubmitted) {
                    setNotification("Submitted Routing Sheet");
                    props.setHasSubmitted(false);
                }
                if (props.setActivityTracker) props.setActivityTracker(false);
                if (closeForm) {
                    // props.setOpenedForm(false);
                    props.closeTheForm();
                    setCloseForm(false);
                }
            }
        }
    }, [props.success]);

    useEffect(() => {
        if (props.pdfBuffer && loadedPDF) {
            setOpenedPDFPreview(true);
            setLoadedPDF(false);
        }
    }, [props.pdfBuffer]);

    const { data } = props;
    const data_id = data.id;

    const submitText = max_approver_level === 4 ? "APPROVE" : ("SUBMIT TO LEVEL " + (max_approver_level + 1));

    const invoices = props.the_invoices ? props.the_invoices : [];

    const usery = getUser();
    console.log('usery', usery);
    let canPreviewInvoice = true;

    const can_approve = checkViewApprove(props);

    console.log('RSheetsResidentialFormActions', props);

    const rsStatus = get(props, 'rsheetData.status', 0);
    const denyNotes = ((rsStatus === 5 || rsStatus === 6 || rsStatus === 7 || rsStatus === 8) && data.deny_notes) ? 
                        <div className="boxed">
                            <h3>Deny Notes</h3>
                            <div>{data.deny_notes}</div>
                        </div>

                    : 
                        null;

    return (
        <div>
            {
                <div>
                    <TextField
                        style={{ width: "100%" }}
                        id="multiline-flexible-notes"
                        label="Internal Notes"
                        multiline
                        rowsMax="4"
                        value={data.notes}
                        onChange={(e) => {
                            props.updateDataObj("notes", e.target.value);
                        }}
                        margin="normal"
                    />
                    <hr />
                    {denyNotes}
                </div>
            }
            <Button
                color="primary"
                className="mr-20"
                onClick={() => {
                    setLoadedPDF(true);
                    props.createRsheetPdf({
                        htmlContent: renderHTML(data, props.rsheetData, props.the_invoices),
                    });
                }}
            >
                PREVIEW PDF
            </Button>
            {!props.viewOnly && (
                <Button
                    color="white"
                    className="mr-20"
                    onClick={() => {
                        if (!data.project_address || !data.project_name) {
                            return setNotification('Please select a property with address and project name to begin saving.')
                        }
                        props.save();
                    }}
                >
                    SAVE
                </Button>
            )}
            
            {!props.viewOnly && (
                <Button
                    color="success"
                    className="mr-20"
                    onClick={() => {
                        handleApproveOrSubmit();
                    }}
                >
                    {submitText}
                </Button>
            )}
            
            {!props.viewOnly && max_approver_level > 2 && invoices.length > 0 && (
                <Button
                    className="mr-20"
                    color="primary"
                    onClick={() => {
                        handleGenerateInvoice();
                    }}
                >
                    {submitText} &amp; GENERATE INVOICE
                </Button>
            )}

            {(invoices.length > 0) && <Button
                className="mr-20"
                color="white"
                onClick={() => {
                    // handlePreviewInvoice();
                    setOpenedChooseInvoice(true);
                }}
            >
                PREVIEW INVOICE
            </Button>}

            {openedChooseInvoice && <InvoiceChoose 
                data={data}
                close={() => {
                    setOpenedChooseInvoice(false);
                }}
                the_invoices={props.the_invoices}
            />}
            
            {(!props.viewOnly && max_approver_level && data_id) &&
                props.tab !== "my_drafts" && 
                props.tab !== "user_drafts" && <Button
                    color="rose"
                    className="mr-20"
                    onClick={() => {
                        // APPROVER REJECTION
                        setOpenedDenyModal(true)
                    }}
                >
                    DENY
                </Button>}
            
            {openedPDFPreview && (
                <RSheetsPDFPreview
                    close={() => {
                        props.createRsheetPdf(null);
                        setOpenedPDFPreview(false);
                    }}
                    open={openedPDFPreview}
                    pdfData={props.pdfBuffer ? props.pdfBuffer : null}
                />
            )}
            
            {notification && (
                <Notification
                    open={notification ? true : false}
                    close={() => {
                        if (notification === "Submitted Routing Sheet") {
                            props.closeTheForm();
                        }
                        setNotification("");
                    }}
                    message={notification}
                />
            )}
            
            {openedDenyModal && <RSheetsDenyModal 
                data={data}
                setData={props.setData}
                open={openedDenyModal}
                close={() => { setOpenedDenyModal(false) }}
                choose={(status_to_change_to) => {
                    // APPROVER REJECTION
                    setCloseForm(true);
                    const recordHistory = {
                        rs_id: data.id,
                        json_data: data,
                        status: status_to_change_to
                    };
                    props.updateRsheet({
                        id: data.id,
                        json_data: JSON.stringify(data),
                        formDataObj: props.formDataObj,
                        status: status_to_change_to,
                        project_name: data.project_name
                    }, null, recordHistory);
                    props.setFormDataObj({});
                }}
            />}

            {invoicePreview && <InvoicePreview 
                rsType={1}
                data={invoicePreview}
                close={() => {
                    setInvoicePreview(null);
                }}
            />}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        error: state.rs.error,
        success: state.rs.success,
        rsheetData: state.rs.rsheetData,
        pdfBuffer: state.rs.pdfBuffer,
        invoiceID: state.invoice.invoiceID,
        internalReviewers: state.rs.internal_reviewers_choices,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createRsheet: (data, invoiceData = null, recordHistory) => {
            dispatch(actions.createRsheet(data, invoiceData, recordHistory));
        },
        getRsheets: (params) => {
            dispatch(actions.getRsheets(params));
        },
        updateRsheet: (params, invoiceData = null, recordHistory, pdfObj = null, invo_data = null) => {
            dispatch(actions.updateRsheet(params, invoiceData, recordHistory, pdfObj, invo_data));
        },
        createRsheetPdf: (params) => {
            dispatch(actions.createRsheetPdf(params));
        },
        createRsheetFiles: (params) => {
            dispatch(actions.createRsheetFiles(params));
        },
        createInvoiceEntry: (data) => {
            dispatch(actions.createInvoiceEntry(data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RSheetsResidentialFormActions);
